import { fromJS } from "immutable";

import types from "./types";

export const initialState = fromJS({
  total: 0,
  limit: 10,
  currentPage: 1,
  totalPages: null,
  loading: false,
});

export default (scope) => {
  if (scope && typeof scope !== "string")
    throw new Error(`${scope} must be of type string, you passed ${typeof scope}`);

  return (state = initialState, action) => {
    if (scope && scope !== (action.meta && action.meta.scope)) return state;

    const { type, payload } = action;

    switch (type) {
      case types.SET_INITIAL: {
        const total = parseInt(payload.total);
        const limit = parseInt(payload.limit || state.get("limit"));
        const totalPages = Math.ceil(total / limit);

        const page = parseInt(payload.page) || 1;

        return state.withMutations((state) => {
          state.set("total", total);
          state.set("currentPage", page);
          state.set("limit", limit);
          state.set("totalPages", totalPages);
        });
      }

      case types.NEXT_PAGE: {
        const nextPage = state.get("currentPage") + 1;

        if (nextPage > state.get("totalPages")) return state;

        return state.set("currentPage", nextPage);
      }

      case types.PREVIOUS_PAGE: {
        const previousPage = state.get("currentPage") - 1;

        if (previousPage < 1) return state;

        return state.set("currentPage", previousPage);
      }

      case types.SET_PAGE: {
        const { page } = payload;

        if (page < 1) {
          return state.set("currentPage", 1);
        } else if (page > state.get("totalPages")) {
          return state.set("currentPage", state.get("totalPages") + 1);
        } else {
          return state.set("currentPage", page);
        }
      }
      case types.TOGGLE_LOADING: {
        return state.set("loading", payload);
      }

      case types.RESET: {
        return initialState;
      }

      default: {
        return state;
      }
    }
  };
};
